import React, { useState, useEffect } from "react";
import BotCard from "./BotCard";
import SortBar from "./SortBar";
import Filter from "./Filter";

function BotCollection({ onBotClick, dischargeBot }) {
  const [bots, setBots] = useState([]);
  const [filteredBots, setFilteredBots] = useState([]);

  useEffect(() => {
    fetch("https://gist.githubusercontent.com/Abdikhafar-hub/aa483126f633a616d0beaf4d66d87a61/raw/dad52f5b471ee92fadf55f5d8ad0d0baa45070d3/db.json")
      .then((response) => response.json())
      .then((data) => {
        setBots(data.bots);
        setFilteredBots(data.bots);
      });
  }, []);

  const handleSort = (criterion) => {
    const sorted = [...filteredBots].sort((a, b) => b[criterion] - a[criterion]);
    setFilteredBots(sorted);
  };

  const handleFilter = (botClass) => {
    const filtered = bots.filter((bot) => bot.bot_class === botClass);
    setFilteredBots(filtered);
  };

  return (
    <div>
      <SortBar onSort={handleSort} />
      <Filter onFilter={handleFilter} />
      <div className="bot-collection">
        {filteredBots.map((bot) => (
          <BotCard
            key={bot.id}
            bot={bot}
            handleBotClick={onBotClick}  
            dischargeBot={dischargeBot}
          />
        ))}
      </div>
    </div>
  );
}

export default BotCollection;
